import script from "./ViewList.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewList.vue?vue&type=script&setup=true&lang=js"

import "./ViewList.vue?vue&type=style&index=0&id=87477b60&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87477b60"]])

export default __exports__